import { fakePromisePrototype } from './functions/fakePromise';
Promise.fake = fakePromisePrototype;
export default {};
//# sourceMappingURL=index.js.map